import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogIn, Heart, PieChart, ShieldCheck } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { IMAGES } from '../data/mock';
import logo from '../assets/farmway-logo.png';

const perks = [
  { icon: Heart, text: 'Save and follow your favourite projects' },
  { icon: PieChart, text: 'Track a personalised portfolio dashboard' },
  { icon: ShieldCheck, text: 'Secure, one-click access with Google' },
];

export default function Login() {
  const { user, loading, login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) navigate('/dashboard', { replace: true });
  }, [user, loading, navigate]);

  return (
    <section className="relative flex min-h-screen items-center justify-center overflow-hidden px-5 py-28">
      <div className="absolute inset-0">
        <img src={IMAGES.rollingHills} alt="" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-br from-farmway-green via-farmway-green/92 to-farmway-green-dark" />
      </div>

      <div className="relative w-full max-w-md rounded-3xl border border-white/10 bg-farmway-green-dark/80 p-8 backdrop-blur-xl sm:p-10">
        <img src={logo} alt="Farmway" className="h-14 w-14 rounded-2xl object-cover ring-1 ring-farmway-leaf/30" />
        <span className="eyebrow mt-6 block">Investor Access</span>
        <h1 className="mt-3 display-xl text-4xl text-farmway-cream">Welcome to Farmway</h1>
        <p className="mt-3 text-farmway-cream/70">
          Sign in to save projects and track your portfolio across future-proof farmland and agribusiness.
        </p>

        <button onClick={login} className="btn-gold mt-8 w-full">
          <LogIn className="h-4 w-4" /> Continue with Google
        </button>

        <ul className="mt-8 space-y-3">
          {perks.map((p) => (
            <li key={p.text} className="flex items-center gap-3 text-sm text-farmway-cream/80">
              <span className="grid h-8 w-8 place-items-center rounded-full bg-farmway-gold/15 text-farmway-gold">
                <p.icon className="h-4 w-4" />
              </span>
              {p.text}
            </li>
          ))}
        </ul>

        <p className="mt-8 text-center text-xs text-farmway-cream/40">
          Portfolio figures shown after login are demo data for preview purposes.
        </p>
      </div>
    </section>
  );
}
